const { getOfflineModeSetting, getOfflineAssignments } = require('utilities/offlineUtilities');
const _ = require('underscore');
const Vue = require('vue');
const page = require('page');
const Util = require('./utilities');
const Store = require('./kvstore');
const routeContext = require('core/routeContext');
const pubsub = require('events/pubsub');
require('./vue-filters');
require('core/printTracker');
require('core/errorTracker');
const Main = Vue.extend(require('components/main.vue').default);
const userContext = require('core/userContext');
const messages = require('core/messages');
const model = require('model/model');
require('utilities/pageViewTracker');
require('utilities/campaignUtilities');

// Check for campaignId in URL, not just existence of cookie
const urlUtilities = require('utilities/urlUtilities');
const campaignId = urlUtilities.getSearchParameter('campaignId');
const analyticsUtilities = require('utilities/analyticsUtilities');
const journeyUtilities = require('utilities/journeyUtilities');
const initJourneys = journeyUtilities.initJourneys;
const fireEvent = analyticsUtilities.fireEvent;
const CAMPAIGN_LANDED = analyticsUtilities.events.CAMPAIGN_LANDED;

const logger = require('utilities/logger');
const { getGenericGCAuthURL } = require('utilities/googleClassroomUtilities');

Vue.config.silent = true;

getOfflineModeSetting().then(mode => {
	var timeout = model.get('tokenExpiration');
	if (mode === false && (!timeout || timeout < Date.now())) {
		userContext.reset();
	}
	getOfflineAssignments();
});

var STUDENT_MESSAGE_PAGES = {
	// Pages on which student site status messages should show
	student: true
};
var TEACHER_MESSAGE_PAGES = {
	// Pages on which teacher site status messages should show
	'find-content': true,
	'my-tools': true,
	assignments: true,
	'class-admin': true
};

var MODAL_OPTIONS = {
	modalActiveClass: 'modal--active', // Class applied to active modal windows
	modalBGClass: 'modal-bg', // Class applied to the modal background overlay
	backspaceClose: false // Boolean, whether or not to enable backspace/delete button modal closing
};

Store.set('MODAL_OPTIONS', MODAL_OPTIONS);

if (campaignId) {
	fireEvent(CAMPAIGN_LANDED);
}

var vueApp = new Main(),
	$body = $('body');

/**
 * When navigating to new routes via a non-absolute uri IE does a weird thing, it passes
 * us the partial URL rather than making it absolute. As such, this partial URL isn't handled
 * correctly by page.js. So what we do here is join the partial URL to the current one so that
 * we can redirect again and do things right.
 * @param  {page.js context} oldContext The current context in vueApp
 * @param  {page.js context} newContext The garbage context IE just gave us via page.js
 */
function doIERedirect(oldContext, newContext) {
	newContext.parsedPath = Util.parsePath(newContext);

	var uri = Util.joinUri(oldContext.parsedPath.uri, newContext.parsedPath.uri);

	if (newContext.querystring) {
		uri += '?' + newContext.querystring;
	}

	if (newContext.hash) {
		uri += '#' + newContext.hash;
	}
	logger.info('redirect for IE bug from ', newContext.parsedPath.uri, ' to ', uri);
	page.redirect(uri);

	// The IE redirect may be triggered by navigation to an anchor within the page,
	// in that case, we may not actually scroll to it due to another (apparent) IE
	// quirk. So we'll force the issue by broadcasting a message for all the scroll-target
	// directives to resend their ready events. This will cause scroll-target-helper to
	// scroll to the right one when it receives the message.
	setTimeout(function () {
		pubsub.publish('scroll-target-reset');
	}, 30);
}

/**
 * Creates a callback suitable for use with page.js and registers it against the route passed
 *
 * @param  {string} name the name of the route component (defined as 'route-*' elsewhere,
 *                       but without route- here)
 * @param  {object} opts An optional object to specify security options for the route
 *                       Properties (default)
 *                       public (false)         - if true, allow non logged in access
 *                       site ('teacher')       - 'teacher' or 'student', defines which sub-site
 *
 */

function vueComponentRoute(route, name, opts) {
	// merge opts with default options
	opts = $.extend(
		true,
		{
			// defaults
			public: false,
			site: 'teacher',
			hideNav: false,
			staticLogo: false
		},
		opts
	);

	page(route, function (ctx) {
		if (ctx.pathname.indexOf('/v1') !== -1 || ctx.pathname.indexOf('/v2') !== -1) {
			window.location = ctx.canonicalPath;

			return;
		}

		if (ctx.hash === 'verified' && userContext.loggedIn()) {
			var userContextData = model.get('userContext');

			userContextData.verified = true;

			model.set('userContext', userContextData);
		}

		let oldPath = {
			p: routeContext && routeContext.path
		};
		let updatedPath = {
			p: ctx && ctx.path
		};

		ctx.route = name;

		routeContext.set(ctx);

		// set current site from current route, or default to the current
		// route's site if not set
		var possibleSites = [opts.site, vueApp.currentRoute.site, 'teacher'];

		// take the first site choice that doesn't say 'both'
		// so try the site for the old route, then try the site for the
		// route that's being loaded, finally just default to teacher
		var currentSite = _.filter(possibleSites, function (s) {
			return s && s !== 'both';
		})[0];

		ctx.site = currentSite;

		if ((route === '*' || route === '/') && ctx.canonicalPath.match(/^(\.\.?\/|#|\?)/)) {
			logger.info('IE redirect needed');
			doIERedirect(vueApp.routeContext, ctx);
			return;
		}

		// page.js doesn't parse query string or split out the uri, do that now
		ctx.parsedPath = Util.parsePath(ctx);
		if (ctx.hash) {
			ctx.hashes = ctx.hash.split('/');
		} else {
			ctx.hashes = [];
		}

		vueApp.currentRoute = {};

		vueApp.titleOverride = opts.title;

		vueApp.routeContext = ctx;

		vueApp.hideNav = opts.hideNav;

		vueApp.staticLogo = opts.staticLogo;

		vueApp.modelData = {
			account: 'userContext'
		};

		let alreadyLoggedInGoogleStudent =
			userContext.loggedIn() &&
			userContext.isStudent() &&
			(ctx.route === 'student-workspace' || ctx.route === 'article-dashboard') &&
			opts.site === 'student' &&
			ctx.parsedPath &&
			ctx.parsedPath.getQueryParam('classCode');

		const gcAddon = model.get('gcAddon');

		if (
			(!opts.public && !userContext.loggedIn()) || //unauthd, access private route
			(!opts.public && currentSite !== opts.site && opts.site !== 'both') || //trying to access other context
			(ctx.site === 'student' && !opts.public && userContext.loggedIn() && !userContext.isStudent()) || //teacher accessing student
			(userContext.loggedIn() && userContext.isStudent() && opts.site === 'teacher' && ctx.pathname !== '/pwr') || //student accessing teacher
			alreadyLoggedInGoogleStudent
		) {
			// Google Student already logged in, trying to access assignment
			Store.set('current_ctx', ctx);

			if (gcAddon) {
				page('/classroom-addon');
			} else if (opts.site === 'student' || (!userContext.loggedIn() && opts.site === 'both' && !opts.public)) {
				// opts.site === 'both' && !opts.public - Indicates an authenticated route available to teachers and students
				if ((ctx.route === 'student-workspace' || ctx.route === 'article-dashboard') && ctx.parsedPath && ctx.parsedPath.getQueryParam('classCode')) {
					// student-workspace with classCode param is a special link from Google Classroom, see WEB-1223
					let url = getGenericGCAuthURL(
						new URLSearchParams({
							url: ctx.pathname,
							classCode: ctx.parsedPath.getQueryParam('classCode')
						})
					);

					/// Allows testing of GC redirect
					if (window.readworks && window.readworks.config && window.readworks.config.rwtesting) {
						url = '/test-success';
					}
					document.location = url;
				} else {
					page('/student-authentication?url=' + encodeURIComponent(ctx.canonicalPath));
				}
			} else if (opts.site === 'teacher') {
				page.redirect('/?url=' + encodeURIComponent(ctx.canonicalPath) + '#login');
			}

			return;
		}

		if (opts.site === 'teacher' && userContext.loggedIn() && !userContext.isStudent()) {
			initJourneys();
		}

		pubsub.publish('route-changing', updatedPath, oldPath);

		// scroll to the top when the uri changes
		// otherwise (for example), user may scroll down looking at articles
		// and click an article, and start viewing that article already scrolled
		// halfway down the page
		var lastUri = Store.get('lastScrolledUri');
		if (ctx.parsedPath.uri !== lastUri) {
			$(window).scrollTop(0);
			Store.set('lastScrolledUri', ctx.parsedPath.uri);
			document.body.focus();
		}

		// if we're going to a new route (not just changing hashes) close dialogs
		if (ctx.path !== vueApp.routeContext.path) {
			Util.closeModals();
		}

		var newRoute = $.extend(true, { component: 'route-' + name }, opts);

		// Due to issues having vue template syntax in index.html re: handlebars also processing index.html on the node side,
		// we must added these classes to the body via jQuery.
		if (newRoute.site === 'teacher') {
			$body.removeClass('site-student').removeClass('site-both');
		} else if (newRoute.site === 'student') {
			$body.removeClass('site-teacher').removeClass('site-both');
		} else {
			$body.removeClass('site-student').removeClass('site-teacher');
		}

		var bodyClasses = $body.attr('class');

		if (bodyClasses) {
			$body
				.attr('class')
				.split(' ')
				.forEach(function (clazz) {
					if (clazz.indexOf('route-') === 0) {
						$body.removeClass(clazz);
					}
				});
		}

		vueApp.currentRoute = newRoute;

		if (opts.state) {
			for (var k in opts.state) {
				if (typeof model.get(k) === 'undefined') {
					model.set(k, opts.state[k]);
				}
			}
		}

		$body.addClass('site-' + vueApp.currentRoute.site).addClass(vueApp.currentRoute.component);

		pubsub.publish('hide-tooltips');

		if (messages.showTeacherMessage && !model.get('teacherStatusMessageShown') && name in TEACHER_MESSAGE_PAGES) {
			Util.openModal('#teacher-message');

			model.set('teacherStatusMessageShown', true);
		}

		if (messages.showStudentMessage && !model.get('studentStatusMessageShown') && name in STUDENT_MESSAGE_PAGES) {
			Util.openModal('#student-message');

			model.set('studentStatusMessageShown', true);
		}
	});
}

// Define directives
Vue.directive('scroll-target', require('./directives/scroll-target'));
Vue.directive('scroll-target-helper', require('./directives/scroll-target-helper'));
Vue.directive('scroll-target-helper-local', require('./directives/scroll-target-helper-local'));
Vue.directive('progress-click', require('./directives/progress-click'));
Vue.directive('tooltip', require('./directives/tooltip'));
Vue.directive('safe-textarea-placeholder', require('./directives/safe-textarea-placeholder'));
Vue.directive('autosize-textarea', require('./directives/autosize-textarea'));
Vue.directive('focus-if', require('./directives/focus-if'));
Vue.directive('margin-down-to', require('./directives/margin-down-to'));
Vue.directive('iframe-scaled-to-parent', require('./directives/iframe-scaled-to-parent'));
Vue.directive('touched-field', require('./directives/touched-field'));
Vue.directive('lazy-loader', require('./directives/lazy-loader'));

// Define non-route components
Vue.component('question', require('./components/question.vue').default);
Vue.component('auto-form-row', require('./components/auto-form-row.vue').default);
Vue.component('date-picker', require('./components/date-picker.vue').default);
Vue.component('assignment-modal', require('./components/assignment-modal.vue').default);
Vue.component('password-modal', require('./components/password-modal.vue').default);
Vue.component('email-modal', require('./components/email-modal.vue').default);
Vue.component('create-class-modal', require('./components/create-class-modal.vue').default);
Vue.component('student-workspace-question', require('./components/student/student-workspace-question.vue').default);
Vue.component('article-aside', require('./components/article-aside.vue').default);
Vue.component('question-score-chooser', require('./components/question-score-chooser.vue').default);
Vue.component('grade-badge', require('./components/grade-badge.vue').default);
Vue.component('add-kids-modal', require('./components/add-kids-modal.vue').default);
Vue.component('sr-tr-redirect-modal', require('./components/sr-tr-redirect-modal.vue').default);
Vue.component('drupal-name-modal', require('./components/drupal-name-modal.vue').default);
Vue.component('share-buttons', require('./components/share-buttons.vue').default);
Vue.component('teacher-authentication', require('./components/routes/authentication/teacher-authentication.vue').default);
Vue.component('user-setup-form', require('./components/user-setup-form.vue').default);
Vue.component('reassign-modal', require('./components/reassign-modal.vue').default);
Vue.component('answer-note', require('./components/teacher/answer-note.vue').default);
Vue.component('popup', require('./ui/popup.vue').default);
Vue.component('annotated-text', require('./components/annotated-text.vue').default);
Vue.component('highlighting-prompt', require('./components/highlighting-prompt.vue').default);
Vue.component('note-icon', require('./components/note-icon.vue').default);
Vue.component('show-hide-markup-icon', require('./components/show-hide-markup-icon.vue').default);
Vue.component('modal', require('./components/modal.vue').default);
Vue.component('vimeo-player', require('./components/vimeo-player.vue').default);
Vue.component('delete-class-modal', require('./components/delete-class-modal.vue').default);
Vue.component('archive-class-modal', require('./components/archive-class-modal.vue').default);
Vue.component('article-ebook', require('./components/article-ebook.vue').default);
Vue.component('outbound-link', require('./components/outbound-link.vue').default);

// Define nav components
Vue.component('student-nav', require('./components/nav/student-nav.vue').default);
Vue.component('teacher-nav', require('./components/nav/teacher-nav.vue').default);
Vue.component('lessons-and-units-nav', require('./components/nav/lessons-and-units-nav.vue').default);
Vue.component('unauth-nav', require('./components/nav/unauth-nav.vue').default);

// Define route components
Vue.component('route-home', require('./components/routes/home.vue').default);
Vue.component('route-404', require('./components/routes/notfound.vue').default);
Vue.component('route-my-account', require('./components/routes/my-account.vue').default);
Vue.component('route-my-tools', require('./components/routes/my-tools.vue').default);
Vue.component('route-find-content', require('./components/routes/find-articles.vue').default);
Vue.component('route-article', require('./components/routes/article.vue').default);
Vue.component('route-assignments', require('./components/routes/assignments.vue').default);
Vue.component('route-assessment', require('./components/routes/assessment.vue').default);
Vue.component('route-class-admin', require('./components/routes/class-admin.vue').default);
Vue.component('route-student', require('./components/routes/student.vue').default);
Vue.component('route-student-library', require('./components/routes/student-library.vue').default);
Vue.component('route-student-workspace', require('./components/routes/student-workspace.vue').default);
Vue.component('route-student-cva-workspace', require('./components/routes/student-cva-workspace.vue').default);
Vue.component('route-student-knowledge-inventory-workspace', require('./components/routes/student-knowledge-inventory-workspace.vue').default);
Vue.component('route-article-dashboard', require('./components/routes/article-dashboard.vue').default);
Vue.component('route-student-authentication', require('./components/routes/authentication/student-authentication.vue').default);
Vue.component('route-teacher-authentication', require('./components/routes/authentication/teacher-authentication.vue').default);
Vue.component('route-teacher-signup', require('./components/routes/teacher-signup.vue').default);
Vue.component('route-rostering-selection', require('./components/routes/rostering-selection.vue').default);
Vue.component('route-change-password', require('./components/routes/change-password.vue').default);
Vue.component('route-my-classes', require('./components/routes/my-classes.vue').default);

Vue.component('route-teacher-tips', require('./components/routes/teacher-tips.vue').default);
Vue.component('route-teacher-leaders-2017-18', require('./components/routes/teacher-leaders-2017-18.vue').default);
Vue.component('route-florida-teacher-leaders-2017-18', require('./components/routes/florida-teacher-leaders-2017-18.vue').default);
Vue.component('route-vocabulary-quest-beta', require('./components/routes/vocabulary-quest-beta.vue').default);
Vue.component('route-family-book-of-knowledge', require('./components/routes/family-book-of-knowledge.vue').default);
Vue.component('route-article-a-day-at-home-digital', require('./components/routes/article-a-day-at-home-digital.vue').default);
Vue.component('route-article-a-day-at-home-print', require('./components/routes/article-a-day-at-home-print.vue').default);
Vue.component('route-scope-and-sequence-redirect', require('./components/routes/scope-and-sequence-redirect.vue').default);

//Onboarding
Vue.component('route-onboarding-article-a-day', require('./components/routes/onboarding/article-a-day.vue').default);
Vue.component('route-onboarding-role', require('./components/routes/onboarding/role.vue').default);
Vue.component('route-onboarding-class-name', require('./components/routes/onboarding/class-name.vue').default);
Vue.component('route-onboarding-add-students', require('./components/routes/onboarding/add-students.vue').default);

Vue.component('route-diagnostic', require('./components/routes/diagnostic.vue').default);

Vue.component('route-privacy', require('./components/routes/privacy.vue').default);
Vue.component('route-data-breach-plan', require('./components/routes/data-breach-plan.vue').default);
Vue.component('route-terms', require('./components/routes/terms.vue').default);

Vue.component('route-faq', require('./components/routes/faq.vue').default);
Vue.component('route-shared-device', require('./components/routes/shared-device.vue').default);
Vue.component('route-binder', require('./components/routes/binder.vue').default);

Vue.component('route-drupal-harness', require('./components/routes/drupal-harness.vue').default);
Vue.component('route-drupal-document-harness', require('./components/routes/drupal-document-harness.vue').default);
Vue.component('route-lessons-and-units', require('./components/routes/lessons-and-units.vue').default);

Vue.component('route-google-token', require('./components/routes/google-token.vue').default);
Vue.component('route-classroom-addon', require('./components/routes/classroom-addon.vue').default);

Vue.component('route-promotional-collection', require('./components/routes/promotional-collection.vue').default);

Vue.component('route-teacher-guide', require('./components/routes/teacher-guide.vue').default);
Vue.component('route-webinars', require('./components/routes/webinars.vue').default);

Vue.component('route-student-research-assessment-workspace', require('./components/routes/student-research-assessment-workspace.vue').default);

Vue.component('route-printing-article', require('./components/routes/printing-article.vue').default);

// Define routes (see vueComponentRoute)
// TODO: document route options
vueComponentRoute('/', 'home', { public: true, site: 'both' });
vueComponentRoute('/pwr', 'home', { site: 'teacher', public: true });
vueComponentRoute('/my-account', 'my-account', { site: 'teacher' });
vueComponentRoute('/my-tools', 'my-tools', { site: 'teacher' });
vueComponentRoute('/find-content', 'find-content', { site: 'teacher', public: true });
vueComponentRoute('/article/:title/:article', 'article', { site: 'teacher', public: true });
vueComponentRoute('/article/:article', 'article', { site: 'teacher', public: true });
vueComponentRoute('/assignments', 'assignments', { site: 'teacher' });
vueComponentRoute('/assignment/:classCode/:assignmentId/:tab', 'assessment', { site: 'teacher' });
vueComponentRoute('/class-admin', 'class-admin', { site: 'teacher' });
vueComponentRoute('/rostering-selection', 'rostering-selection', { site: 'teacher' });
vueComponentRoute('/teacher-signup', 'teacher-signup', { public: true, site: 'both' });
vueComponentRoute('/parent-signup', 'teacher-signup', { public: true, site: 'both' });

// make sure any old links or mistakes going to /join get re-routed as they should
page('/join', '/student');
vueComponentRoute('/student', 'student', { site: 'student' });
vueComponentRoute('/student-library', 'student-library', { site: 'both' });
vueComponentRoute('/student-workspace/:aid/:pid?', 'student-workspace', { site: 'both' });
vueComponentRoute('/student-cva-workspace/', 'student-cva-workspace', { site: 'student' });
vueComponentRoute('/student-knowledge-inventory-workspace/', 'student-knowledge-inventory-workspace', { site: 'both' });
vueComponentRoute('/article-dashboard/:aid', 'article-dashboard', { site: 'both' });
vueComponentRoute('/student-authentication', 'student-authentication', { site: 'student', public: true });
vueComponentRoute('/change-password', 'change-password', { site: 'student', public: true });
vueComponentRoute('/my-classes', 'my-classes', { site: 'student' });

vueComponentRoute('/privacy', 'privacy', { site: 'both', public: true });
vueComponentRoute('/data-breach-plan', 'data-breach-plan', { site: 'both', public: true });
vueComponentRoute('/terms', 'terms', { site: 'both', public: true });
vueComponentRoute('/teacher-tips', 'teacher-tips', { site: 'teacher' });
vueComponentRoute('/teacher-leaders-2017-18', 'teacher-leaders-2017-18', { site: 'teacher' });
vueComponentRoute('/florida-teacher-leaders-2017-18', 'florida-teacher-leaders-2017-18', { site: 'teacher' });
// vueComponentRoute('/vocabulary-quest-beta', 'vocabulary-quest-beta', { site: 'teacher' });

// Onboarding routes
vueComponentRoute('/onboarding-article-a-day', 'onboarding-article-a-day', { site: 'teacher', hideNav: true });
vueComponentRoute('/onboarding-role', 'onboarding-role', { site: 'teacher', hideNav: true, staticLogo: true });
vueComponentRoute('/onboarding-class-name', 'onboarding-class-name', { site: 'teacher', hideNav: true });
vueComponentRoute('/onboarding-add-students', 'onboarding-add-students', { site: 'teacher', hideNav: true });

vueComponentRoute('/scope-and-sequence', 'scope-and-sequence-redirect', { site: 'teacher', public: false });

vueComponentRoute('/family-book-of-knowledge', 'family-book-of-knowledge', { site: 'teacher', public: true });
vueComponentRoute('/article-a-day-at-home-digital', 'article-a-day-at-home-digital', { site: 'teacher', public: true });
vueComponentRoute('/article-a-day-at-home-print', 'article-a-day-at-home-print', { site: 'teacher', public: true });

vueComponentRoute('/diagnostic', 'diagnostic', { site: 'both', public: true });

vueComponentRoute('/faq-old', 'faq', { site: 'both', public: true });
vueComponentRoute('/shared-device', 'shared-device', { site: 'teacher', public: true });
vueComponentRoute('/binder', 'binder', { site: 'teacher' });
vueComponentRoute('/user/binder', 'binder', { site: 'teacher' });

vueComponentRoute('/lessons-and-units:path(.*)', 'lessons-and-units', { site: 'teacher', public: true });
vueComponentRoute('/lessons:path(.*)?', 'drupal-harness', { site: 'teacher', public: true });
vueComponentRoute('/modal/nojs/pdf/:path(.*)', 'drupal-document-harness', { site: 'teacher' });
vueComponentRoute('/user/alignment', 'drupal-harness', { site: 'teacher', public: true });

vueComponentRoute('/google-token', 'google-token', { site: 'both', public: false });
vueComponentRoute('/classroom-addon', 'classroom-addon', { site: 'both', public: true });

vueComponentRoute('/promotional-collection', 'promotional-collection', { site: 'teacher', public: true });

vueComponentRoute('/teacher-guide:path(.*)', 'teacher-guide', { site: 'teacher', public: true });
vueComponentRoute('/webinars:path(.*)', 'webinars', { site: 'teacher', public: true });

vueComponentRoute('/student-research-assessment-workspace', 'student-research-assessment-workspace', { site: 'student', public: false });

vueComponentRoute('/printing-article', 'printing-article', { site: 'teacher', public: false });

vueComponentRoute('/books/passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Reading Passages'
});

vueComponentRoute('/books/:path(.*)', 'drupal-harness', { site: 'teacher', public: true });

vueComponentRoute('/rw/informational-articles-build-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Articles to Build Knowledge',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/black-history-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Black History Month',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/summer-reading-rising-1st-2nd-graders', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading - Rising 1st & 2nd Graders',
	state: { q: ['summerreads'], g: ['16', '17', '18', '19'], t: 0 }
});

vueComponentRoute('/rw/build-academic-vocabulary-k-12-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Build Academic Vocabulary with K-12 Texts',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/introducing-k-2-paired-text-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Introducing K-2 Paired Text Question Sets',
	state: { g: ['16', '17', '18'], t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-12-passages-build-reading-stamina', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages to Build Reading Stamina',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/paired-non-fiction-and-literary-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Paired Non-fiction and Literary Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-12-passages-academic-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages with Academic Vocabulary',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/summerreads-rising-3rd-4th-5th-graders', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'SummerReads for Rising 3rd, 4th, 5th Graders',
	state: { q: ['summerreads'], g: ['19', '18', '20', '21', '22'], t: 0 }
});

vueComponentRoute('/rw/6th-12th-grade-passages-building-reading-stamina', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Passages for Building Reading Stamina',
	state: { g: ['343', '323', '22', '346', '347'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/nonfiction-articles-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Nonfiction Articles & Text-Dependent Questions',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/veterans-day-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Veterans Day Passages',
	state: { q: ['veterans day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/spring-and-summer-passages-and-question-sets-based-common-core-lexile-bands', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Spring and Summer Passages and Research-Based Question Sets',
	state: { q: ['summer'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/7th-8th-grade-build-background-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['0'], g: ['343', '323'], t: 12, pt: ['A'] }
});

vueComponentRoute('/new-reading-passages-7th-8th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Reading Passages for 7th & 8th Grade',
	state: { g: ['323', '343'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-2nd-grade-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 2nd Grade Passages & Question Sets',
	state: { g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/celebrate-black-history-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate Black History Month',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/brand-new-passages-new-school-year', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New Passages for the New School Year',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/election-2012', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Election 2012: Presidents & Voting',
	state: { s0: ['0'], q: ['election'], t: 0, pt: ['A'] }
});

vueComponentRoute('/summerreads', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'SummerReads',
	state: { q: ['summerreads'], t: 0 }
});

vueComponentRoute('/rw/k-12-articles-academic-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles with Academic Vocabulary',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/5th-grade-life-science', 'find-content', {
	site: 'teacher',
	public: true,
	title: '5th Grade Life Science',
	state: { s0: ['373', '356'], g: ['21'], t: 0, s: ['356'], pt: ['A'] }
});

vueComponentRoute('/rw/honor-abraham-lincoln-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Honor Abraham Lincoln',
	state: { q: ['Abraham Lincoln'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/6th-12th-grade-authentic-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th-12th Grade Authentic Passages',
	state: { g: ['343', '323', '22', '346', '347'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/summer-reading-rising-6th-12th-graders', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading - Rising 6th-12th Graders',
	state: { q: ['summer'], g: ['21', '22', '323', '343', '347', '346'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-paired-texts-and-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts and Text-Dependent Questions',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/science-articles-text-based-questions-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Articles with Text-Based Questions',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-practice-theme', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages to Practice Theme',
	state: { s0: ['1', '40'], t: 13, k: ['40'] }
});

vueComponentRoute('/rw/fables-myths-legends', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Fables, Myths, & Legends',
	state: { q: ['aesop'], t: 13 }
});

vueComponentRoute('/presidents-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: "Presidents' Day",
	state: { s0: ['0'], q: ['presidents day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/black-history-month-2013', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Black History Month 2013',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/6th-8th-grade-paired-text-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 8th Grade Paired Text Question Sets',
	state: { g: ['343', '323', '22'], t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/problem-solution-passages-k-1', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Problem & Solution Passages for K & 1',
	state: { s0: ['0'], q: ['problem solution'], g: ['16', '17'], t: 0 }
});

vueComponentRoute('/california-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'California Passages',
	state: { q: ['california'], t: 0, pt: ['A'] }
});

vueComponentRoute('/6th-8th-grade-informational-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th-8th Grade Informational Articles',
	state: { g: ['323', '343', '22'], t: 12, pt: ['A'] }
});

vueComponentRoute('/6th-12th-grade-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Vocabulary',
	state: { g: ['323', '343', '347', '346', '22'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-articles-related-water', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles Related to Water',
	state: { q: ['water'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/longer-passages-build-stamina', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Longer Passages to Build Stamina',
	state: { s0: ['0'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/6th-12th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['343', '323', '22', '346', '347'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Social Studies Articles',
	state: { s0: ['372'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-informational-articles-build-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Informational Articles to Build Knowledge',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/celebrate-national-teacher-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate National Teacher Day',
	state: { t: 0 }
});

vueComponentRoute('/physical-science-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Physical Science Passages',
	state: { s0: ['373', '357'], t: 0, s: ['357'], pt: ['A'] }
});

vueComponentRoute('/rw/6th-12th-grade-articles-stem-topics', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['343', '323', '22', '346', '347'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/build-knowledge-science-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Build Knowledge with Science Articles',
	state: { s0: ['373'], t: 12, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-text-dependent-questions-1', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages with Text-Dependent Questions',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-recognize-memorial-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Recognize Memorial Day',
	state: { s0: ['0'], q: ['memorial day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/winter-holiday-season-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Winter & Holiday Season Passages',
	state: { q: ['winter'], t: 0, pt: ['A'] }
});

vueComponentRoute('/national-bullying-prevention-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'National Bullying Prevention Month',
	state: { q: ['bullying'], t: 0, pt: ['A'] }
});

vueComponentRoute('/3rd-5th-grade-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th Grade Literary Passages',
	state: { g: ['19', '20', '21'], t: 13, pt: ['A'] }
});

vueComponentRoute('/k-12th-grade-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Science Articles',
	state: { s0: ['373'], g: ['16', '17', '18', '21', '20', '19', '22', '343', '347', '346', '323'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-passages-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages & Text-Dependent Questions',
	state: { s0: ['0'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/science-articles-text-based-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Articles with Text-Based Questions',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/biographies-and-profiles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Biographies and Profiles',
	state: { q: ['biography'], t: 0 }
});

vueComponentRoute('/rw/informational-articles-text-based-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Articles & Text-Based Questions',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/4th-grade-us-history-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '4th Grade U.S. History Passages',
	state: { s0: ['372', '348'], g: ['20'], t: 0, s: ['348'], pt: ['A'] }
});

vueComponentRoute('/rw/k-2nd-grade-passages-building-reading-stamina', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-2nd Grade Passages for Building Reading Stamina',
	state: { g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/summer-reading-passages-k-8', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading Passages K-8',
	state: { q: ['summer'], g: ['16', '17', '18', '21', '20', '19', '22', '323', '343'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/paired-texts-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Paired Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/paired-texts-and-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Paired Texts and Questions',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/6th-12th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['323', '343', '347', '346', '22'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-grade-articles-stem-topics-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12 Grade Articles on STEM Topics',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/new-k-5-reading-comprehension-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New K-5 Reading Comprehension Passages',
	state: { s0: ['0'], g: ['16', '17', '18', '21', '20', '19'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-stem-passages-paired-literary-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th STEM Articles & Literary Paired Texts',
	state: { s0: ['0'], g: ['21', '20', '19'], t: 13, pt: ['P'] }
});

vueComponentRoute('/rw/practice-making-inferences', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Practice Making Inferences',
	state: { s0: ['1', '7'], t: 0, k: ['7'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12th-grade-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Paired Texts',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['P'] }
});

vueComponentRoute('/rw/informational-paired-texts-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Paired Texts & Question Sets',
	state: { t: 12, pt: ['P'] }
});

vueComponentRoute('/k-2-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K- 2 Literary Passages',
	state: { g: ['16', '17', '18'], t: 13, pt: ['A'] }
});

vueComponentRoute('/rw/new-paired-texts-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Paired Texts & Question Sets',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/technology-engineering-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Technology & Engineering Reading Passages',
	state: { s0: ['373', '358'], t: 0, s: ['358'], pt: ['A'] }
});

vueComponentRoute('/rw/k-8th-grade-winter-passages-lessons', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-8th Grade Winter Passages & Lessons',
	state: { q: ['winter'], g: ['16', '17', '18', '19', '20', '21', '22', '323', '343'], t: 0, pt: ['A'] }
});

vueComponentRoute('/3-5-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th Grade Science Articles',
	state: { s0: ['372', '359'], g: ['19', '20', '21'], t: 0, s: ['359'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-paired-texts-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/k-2-science-articles-comprehension', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-2 Science Articles for Comprehension',
	state: { s0: ['373'], g: ['16', '17', '18'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/science-articles-k-12', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Articles for K-12',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/2nd-grade-life-science-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '2nd Grade Life Science Reading Passages',
	state: { s0: ['373', '356'], g: ['18'], t: 0, s: ['356'], pt: ['A'] }
});

vueComponentRoute('/rw/new-k-12-poems-and-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New K-12 Poems and Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/k-12-paired-texts-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts & Question Sets',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/hurricane-katrina-anniversary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Hurricane Katrina Anniversary',
	state: { q: ['katrina'], t: 0, pt: ['A'] }
});

vueComponentRoute('/earth-day-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Earth Day Reading Passages',
	state: { q: ['earth day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/poems-text-based-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Poems with Text-Based Questions',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/3rd-5th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['19', '20', '21'], t: 13, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/k-1-reading-passages-america', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K & 1 Reading Passages on America',
	state: { q: ['america'], g: ['16', '17'], t: 0, pt: ['A'] }
});

vueComponentRoute('/reading-passages-historical-subjects', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Reading Passages on Historical Subjects',
	state: { s0: ['372', '349'], t: 0, s: ['349'] }
});

vueComponentRoute('/rw/election-day-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Election Day Passages',
	state: { q: ['election'], t: 0 }
});

vueComponentRoute('/rw/literary-passages-text-dependent-questions-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages with Text-Dependent Questions',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/6th-8th-grade-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th-8th Grade Science Articles',
	state: { s0: ['373'], g: ['323', '343', '22'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-grade-articles-stem-topics', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12 Grade Articles on STEM Topics',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/3rd-5th-grade-informational-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th Grade Informational Articles',
	state: { g: ['19', '20', '21'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/celebrate-spring', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate Spring',
	state: { s0: ['0'], q: ['spring'], t: 0, pt: ['A'] }
});

vueComponentRoute('/technology-engineering-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Technology & Engineering Passages',
	state: { s0: ['373', '358'], t: 0, s: ['358'], pt: ['A'] }
});

vueComponentRoute('/presidents-day-2013', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Presidents’ Day 2013',
	state: { s0: ['0'], q: ['presidents day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/science-passages-reading-comprehension', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Passages for Reading Comprehension',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/social-studies-articles-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Social Studies Articles & Text-Dependent Questions',
	state: { s0: ['372'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/national-poetry-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['374', '29'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/kindergarten-1st-grade-passages-spring', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles for Spring',
	state: { q: ['spring'], g: ['16', '17'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-teach-main-idea', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Teach Main Idea',
	state: { s0: ['1', '33'], t: 0, k: ['33'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-science-texts-comprehension', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Texts for Comprehension',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-poems-national-poetry-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Poems for National Poetry Month',
	state: { s0: ['374', '29'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/3rd-grade-life-science', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd Grade - Life Science',
	state: { s0: ['373', '356'], g: ['19'], t: 0, s: ['356'], pt: ['A'] }
});

vueComponentRoute('/thirty-new-6th-8th-grade-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Thirty 6th-8th Grade Passages',
	state: { g: ['22', '323', '343'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/happy-thanksgiving', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Happy Thanksgiving',
	state: { q: ['thanksgiving'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/winter-themed-articles-lessons', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Winter-Themed Articles & Lessons',
	state: { q: ['winter'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/stem-articles-literary-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'STEM Articles & Literary Paired Texts',
	state: { s0: ['373', '358'], t: 13, s: ['358'], pt: ['P'] }
});

vueComponentRoute('/earth-space-science-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Earth & Space Science Passages',
	state: { s0: ['373', '361'], t: 0, s: ['361'], pt: ['A'] }
});

vueComponentRoute('/rw/science', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-and-poems-autumn-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles and Poems for Autumn',
	state: { s0: ['0'], q: ['autumn'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/new-readworks-article-day-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New ReadWorks Article-A-Day Sets',
	state: { s0: ['0'], t: 0, pt: ['AAD'] }
});

vueComponentRoute('/rw/introducing-paired-texts-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Introducing Paired Texts & Question Sets',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-12-passages-evidence-based-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages & Evidence-Based Question Sets',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/thanksgiving-2015', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Thanksgiving 2015',
	state: { q: ['thanksgiving'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-science-articles-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Articles & Question Sets',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Passages & Question Sets',
	state: { s0: ['373'], g: ['21', '20', '19'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['372'], g: ['21', '20', '19'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-passages-related-arts-culture', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages Related to Arts & Culture',
	state: { s0: ['372', '359'], t: 0, s: ['359'], pt: ['A'] }
});

vueComponentRoute('/rw/6th-8th-stem-passages-paired-literary-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th-8th STEM Articles & Literary Paired Texts',
	state: { s0: ['373'], g: ['343', '323', '22'], t: 13, s: ['373'], pt: ['P'] }
});

vueComponentRoute('/rw/earth-day-2015', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Earth Day 2015',
	state: { q: ['earth day'], t: 0 }
});

vueComponentRoute('/rw/brand-new-1st-2nd-grade-stem-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New 1st & 2nd Grade STEM Articles',
	state: { s0: ['373'], g: ['17', '18'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-and-poems-autumn', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles and Poems for Autumn',
	state: { s0: ['0'], q: ['autumn'], t: 0, pt: ['A'] }
});

vueComponentRoute('/brand-new-science-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New Science Passages',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/kindergarten-2nd-grade-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Kindergarten - 2nd Grade Vocabulary',
	state: { g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-winter-break', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for Winter Break',
	state: { s0: ['374'], q: ['winter'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/poems-questions-national-poetry-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Poems & Questions for National Poetry Month',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/k-12-geography-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Geography Articles',
	state: { s0: ['372', '353'], t: 0, s: ['353'] }
});

vueComponentRoute('/rw/celebrate-earth-day-2016', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate Earth Day 2016',
	state: { s0: ['0'], q: ['earth day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-articles-spring', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles for Spring',
	state: { q: ['spring'], t: 0, pt: ['A'] }
});

vueComponentRoute('/k-8th-grade-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-8th Grade Literary Passages',
	state: { s0: ['374'], g: ['16', '17', '18', '19', '20', '21', '343', '323', '22'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-articles-text-based-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles with Text-Based Question Sets',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-national-bullying-prevention-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles for National Bullying Prevention Month',
	state: { s0: ['0'], q: ['bullying'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-poems-and-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Poems and Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-lessons-related-weather', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles & Lessons Related to Weather',
	state: { s0: ['0'], q: ['weather'], t: 0, pt: ['A'] }
});

vueComponentRoute('/9th-12th-grade-science-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '9th-12th Grade Science Passages',
	state: { s0: ['373'], g: ['346', '347'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/more-poems-6th-12th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'More Poems for 6th - 12th Grade',
	state: { s0: ['374', '29'], g: ['347', '346', '22', '323', '343'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/reading-passages-science-topics', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Reading Passages on Science Topics',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-articles-stem-topics', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd- 5th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['21', '20', '19'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-halloween', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles for Halloween',
	state: { s0: ['0'], q: ['halloween'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/presidents-day-2017', 'find-content', {
	site: 'teacher',
	public: true,
	title: "Presidents' Day 2017",
	state: { q: ['presidents day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/california-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'California Articles',
	state: { s0: ['0'], q: ['california'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-philadelphia-museum-art-1', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles from the Philadelphia Museum of Art',
	state: { s0: ['404', '412'], t: 0, cid: ['412'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-practice-inferring', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Practice Inferring',
	state: { s0: ['1', '7'], t: 0, k: ['7'], pt: ['A'] }
});

vueComponentRoute('/k-2-informational-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-2 Informational Articles',
	state: { g: ['16', '17', '18'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/k-12th-grade-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Literary Passages',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-paired-text-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Paired Text Question Sets',
	state: { s0: ['373'], g: ['21', '20', '19'], t: 0, s: ['373'], pt: ['P'] }
});

vueComponentRoute('/rw/literary-passages-help-teach-character', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages to Help Teach Character',
	state: { s0: ['374', '376'], t: 0, s: ['376'] }
});

vueComponentRoute('/rw/literary-passages-k-2nd-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for K - 2nd Grade',
	state: { s0: ['374'], g: ['16', '17', '18'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/thanksgiving-2014-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Thanksgiving 2014 Reading Passages',
	state: { q: ['thanksgiving'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-3rd-5th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for 3rd - 5th Grade',
	state: { s0: ['374'], g: ['19', '20', '21'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/6th-grade-8th-grade-reading-passages-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th Grade - 8th Grade Reading Passages',
	state: { g: ['323', '343', '22'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-2nd-grade-informational-articles-spring', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-2nd Grade Informational Articles for Spring',
	state: { q: ['spring'], g: ['16', '17', '18'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/black-history-month-2', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Black History Month 2',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/9th-12th-grade-build-background-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['0'], g: ['346', '347'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/brand-new-passages-3rd-12th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New Passages for 3rd-12th Grade',
	state: { g: ['347', '22', '323', '343', '21', '20', '19', '346'], t: 0, pt: ['A'] }
});

vueComponentRoute('/new-literary-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Literary Reading Passages',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Articles',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-2nd-grade-articles-stem-topics', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 2nd Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['16', '17', '18'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-6th-8th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for 6th - 8th Grade',
	state: { s0: ['374'], g: ['22', '323', '343'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/4th-8th-grade-related-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '4th-8th Grade Related Literary Passages',
	state: { s0: ['0'], g: ['21', '22', '20', '323', '343'], t: 13, pt: ['A'] }
});

vueComponentRoute('/rw/national-bullying-prevention-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'National Bullying Prevention Month',
	state: { s0: ['0'], q: ['bullying'], t: 0, pt: ['A'] }
});

vueComponentRoute('/social-studies-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Social Studies Reading Passages',
	state: { s0: ['372'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/support-ngss-6th-8th-grade-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Support NGSS with 6th-8th Grade Articles',
	state: { s0: ['373'], g: ['22', '323', '343'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/recognize-veterans-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Recognize Veterans Day',
	state: { q: ['veterans day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-poems-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Poems with Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/k-12th-grade-informational-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12th Grade Informational Articles',
	state: { s0: ['0'], g: ['16', '17', '18', '21', '20', '19', '22', '343', '347', '346', '323'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/articles-election-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles for Election Day',
	state: { s0: ['0'], q: ['election'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/new-articles-and-reading-comprehension-curriculum', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Articles and Reading Comprehension Curriculum',
	state: { s0: ['0'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12th-grade-literary-passages-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Literary Passages & Questions',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/k-12th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['16', '17', '18', '21', '20', '19', '22', '343', '347', '346', '323'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/veterans-day-read-your-kids', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Veterans Day - Read With Your Kids!',
	state: { q: ['veterans day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/reading-passages-social-studies-topics', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Reading Passages on Social Studies Topics',
	state: { s0: ['372'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-social-studies', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['372'], g: ['21', '20', '19'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/spotlight-on-science', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Passages and Research-Based Question Sets',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th Grade Science Articles',
	state: { s0: ['373'], g: ['21', '20', '19'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/native-american-heritage-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Native American Heritage Month',
	state: { s0: ['0'], q: ['native american'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-winter-passages-lessons', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th Grade Winter Passages & Lessons',
	state: { s0: ['0'], q: ['winter'], g: ['21', '20', '19'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/even-more-black-history-month-content', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Even More Black History Month Content',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/native-american-heritage-month-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Native American Heritage Month',
	state: { s0: ['0'], q: ['native american'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/honor-abraham-lincoln', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Honor Abraham Lincoln',
	state: { q: ['Abraham Lincoln'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-8th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['16', '17', '18', '19', '20', '21', '22', '323', '343'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-science-articles-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Science Articles',
	state: { s0: ['373'], g: ['21', '20', '19'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/womens-history-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Womens History Month',
	state: { s0: ['372'], q: ['womens history'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-philadelphia-museum-art', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles from the Philadelphia Museum of Art',
	state: { s0: ['404', '412'], t: 0, cid: ['412'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-teach-cause-effect', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Teach Cause & Effect',
	state: { s0: ['1', '45'], t: 0, k: ['45'], pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages & Text-Dependent Questions',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/native-american-heritage-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Native American Heritage Month',
	state: { s0: ['0'], q: ['Native American'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-paired-texts-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Paired Texts with Question Sets',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['P'] }
});

vueComponentRoute('/rw/brand-new-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New Articles',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-philadelphia-museum-art-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles from the Philadelphia Museum of Art',
	state: { s0: ['404', '412'], t: 0, cid: ['412'], pt: ['A'] }
});

vueComponentRoute('/rw/american-museum-natural-history-passages-readworks-curriculum', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'American Museum of Natural History Passages with ReadWorks Curriculum',
	state: { s0: ['404', '405'], t: 0, cid: ['405'], pt: ['A'] }
});

vueComponentRoute('/rw/literary-passages-k-8th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for K-8th Grade',
	state: { s0: ['374'], g: ['16', '17', '18', '19', '20', '21', '343', '323', '22'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/poetry-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Poetry with Text-Dependent Questions',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/brand-new-k-8-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New K-8 Passages',
	state: { g: ['16', '19', '22', '343', '323', '20', '21', '18', '17'], t: 0, pt: ['A'] }
});

vueComponentRoute('/6th-8th-grade-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th-8th Grade Literary Passages',
	state: { g: ['323', '343', '22'], t: 13, pt: ['A'] }
});

vueComponentRoute('/6th-grade-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th Grade Passages',
	state: { g: ['22'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-paired-texts-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts & Questions',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-12-articles-about-exploration', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles about Exploration',
	state: { q: ['exploration'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-2nd-grade-winter-passages-lessons', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-2nd Grade Winter Passages & Lessons',
	state: { q: ['winter'], g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/primary-sources', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Primary Sources',
	state: { s0: ['0'], q: ['primary source'], t: 0 }
});

vueComponentRoute('/rw/black-history-month-2015', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Black History Month 2015',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/k-12th-grade-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Passages & Question Sets',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/summer-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading Passages',
	state: { q: ['summerreads'], t: 0 }
});

vueComponentRoute('/rw/5th-6th-grade-build-background-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: '5th-6th Grade - Build Background Knowledge',
	state: { s0: ['0'], g: ['21', '22'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/build-knowledge-informational-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Build Knowledge with Informational Articles',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-passages-academic-vocabulary-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages with Academic Vocabulary',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/informational-articles-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/find-evidence-text', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/build-background-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 12 }
});

vueComponentRoute('/rw/build-academic-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/thanksgiving-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { q: ['thanksgiving'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/build-background-knowledge-alt', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 12 }
});

vueComponentRoute('/rw/build-background-knowledge-research-base', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 12 }
});

vueComponentRoute('/rw/rising-1st-and-2nd-summer-reading', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading - Rising 1st & 2nd Graders',
	state: { q: ['summerreads'], g: ['16', '17', '18', '19'], t: 0 }
});

vueComponentRoute('/rw/poems-and-questions-celebrate-national-poetry-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Poems & Questions for National Poetry Month',
	state: { s0: ['374', '29'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/rw/poetry-k-12', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New K-12 Poems and Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/character', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages to Help Teach Character',
	state: { s0: ['1', '4'], t: 12, k: ['4'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12th-grade-literary-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Literary Passages & Questions',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/science-6th-12th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['22', '323', '343', '347', '346'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-passages-new-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles with Academic Vocabulary',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/summer-reading-rising-1st-and-2nd-graders', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading - Rising 1st & 2nd Graders',
	state: { q: ['summerreads'], g: ['16', '17', '18', '19'], t: 0 }
});

vueComponentRoute('/rw/k-12-paired-texts-and-questions-2016', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts and Text-Dependent Questions',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/paired-literary-and-informational-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Paired Non-fiction and Literary Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/passages-related-water', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Articles Related to Water',
	state: { s0: ['0'], q: ['water'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/3rd-5th-grade-science-passages-paired-literary-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th STEM Articles & Literary Paired Texts',
	state: { s0: ['373'], g: ['21', '20', '19'], t: 13, s: ['373'], pt: ['P'] }
});

vueComponentRoute('/rw/new-k-12-informational', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Articles to Build Knowledge',
	state: { s0: ['0'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/support-next-generation-science-standards', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Support NGSS with 6th-8th Grade Articles',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-stem-topics-6th-12th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['22', '323', '343', '346', '347'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-and-1-thanksgiving', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Thanksgiving 2014 Reading Passages',
	state: { s0: ['0'], q: ['thanksgiving'], g: ['16', '17'], t: 0 }
});

vueComponentRoute('/rw/k-12-science-passages-comprehension', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Texts for Comprehension',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-grade-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Paired Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/biographies-and-texts-biographical-elements', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Biographies and Profiles',
	state: { q: ['biography'], t: 0 }
});

vueComponentRoute('/ecosystems', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Ecosystems',
	state: { s0: ['0'], q: ['ecosystem'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/8th-grade-build-background-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['0'], g: ['343'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/veterans-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Recognize Veterans Day',
	state: { q: ['veterans day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/2nd-5th-grade-social-studies', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { s0: ['372'], g: ['21', '20', '19', '18'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-paired-texts-and-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts and Text-Dependent Questions',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/social-studies-and-womens-history', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12th Grade Social Studies Articles',
	state: { s0: ['372'], q: ['womens history'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/text-dependentevidence-based-questions-informational-test-prep', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Nonfiction Articles & Text-Dependent Questions',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/earth-day-422', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate Earth Day 2016',
	state: { q: ['earth day'], t: 0 }
});

vueComponentRoute('/rw/k-12th-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12th Grade Social Studies Articles',
	state: { s0: ['372'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/practice-making-inferencing', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Practice Making Inferences',
	state: { s0: ['1', '7'], t: 0, k: ['7'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-election-day-november-8th', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles for Election Day',
	state: { s0: ['0'], q: ['election'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/paired-literary-and-non-fiction-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Paired Non-fiction and Literary Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-12-informational-paired-texts-and-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Paired Texts & Question Sets',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/spring', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate Spring',
	state: { q: ['spring'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-science-passages-reading-comprehension', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Texts for Comprehension',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/science-2', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Build Knowledge with Science Articles',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/science-k-2nd-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 2nd Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['16', '17', '18'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/winter-themed-passages-lessons', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Winter-Themed Articles & Lessons',
	state: { q: ['winter'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/main-idea', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Teach Main Idea',
	state: { s0: ['1', '33'], t: 0, k: ['33'], pt: ['A'] }
});

vueComponentRoute('/rw/articles-stem-topics-k-2nd-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 2nd Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['16', '17', '18'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/mlk-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Dr. Martin Luther King Jr. Articles & Videos',
	state: { s0: ['0'], q: ['martin luther king'], t: 0, pt: ['A'] }
});

vueComponentRoute('/endangered-animals', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Endangered Animals',
	state: { s0: ['0'], q: ['Endangered Animals'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/science-passages-share-your-grade-team', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th STEM Articles & Literary Paired Texts',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/poetry', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Poems with Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/5th-6th-grade-build-backround-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: '5th-6th Grade - Build Background Knowledge',
	state: { s0: ['0'], g: ['21', '22'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/march-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Paired Texts and Questions',
	state: { s0: ['0'], t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/literary-passages-teach-character', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages to Help Teach Character',
	state: { s0: ['374', '376'], t: 0, s: ['376'] }
});

vueComponentRoute('/rw/election', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Countdown to the Election',
	state: { q: ['election'], t: 0 }
});

vueComponentRoute('/rw/january-2016-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Paired Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/passages-teach-character', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages to Help Teach Character',
	state: { s0: ['1', '4'], t: 0, k: ['4'], pt: ['A'] }
});

vueComponentRoute('/rw/winter', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Winter-Themed Articles & Lessons',
	state: { q: ['winter'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/text-dependentevidence-based-questions-literary-test-prep', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages with Text-Dependent Questions',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['A'] }
});

vueComponentRoute('/rw/evidence-text', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages & Evidence-Based Question Sets',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-2', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for K - 2nd Grade',
	state: { s0: ['374'], g: ['18'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/literary-6-8', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for 6th - 8th Grade',
	state: { s0: ['374'], g: ['22', '323', '343'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/geography-and-societies', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Social Studies Articles & Text-Dependent Questions',
	state: { s0: ['372', '353'], t: 0, s: ['353'], pt: ['A'] }
});

vueComponentRoute('/rw/summer-reading', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Beat the Summer Reading Slump!',
	state: { q: ['summerreads'], t: 0 }
});

vueComponentRoute('/rw/celebrate-fall', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles and Poems for Autumn',
	state: { s0: ['0'], q: ['autumn'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-practice-inferencing', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Practice Inferring',
	state: { s0: ['1', '7'], t: 0, k: ['7'], pt: ['A'] }
});

vueComponentRoute('/rw/rising-3rd-4th-5th-graders-summerreads', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'SummerReads for Rising 3rd, 4th, 5th Graders',
	state: { q: ['summerreads'], g: ['19', '18', '20', '21', '22'], t: 0 }
});

vueComponentRoute('/rw/stem-passages-paired-literary-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th STEM Articles & Literary Paired Texts',
	state: { s0: ['373', '358'], t: 13, s: ['358'], pt: ['P'] }
});

vueComponentRoute('/rw/bullying', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles for National Bullying Prevention Month',
	state: { s0: ['0'], q: ['bullying'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/fables-myths-legends-plays', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Fables, Myths, & Legends',
	state: { q: ['aesop'], t: 13 }
});

vueComponentRoute('/rw/k-12-informational-paired-texts-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Paired Texts & Question Sets',
	state: { t: 12, pt: ['P'] }
});

vueComponentRoute('/rw/native-american-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Native American Heritage Month',
	state: { s0: ['0'], q: ['native american'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12th-grade-authentic-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Passages & Question Sets',
	state: { s0: ['0'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-science-content-comprehension', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Texts for Comprehension',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/american-museum-natural-history-readworks', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'American Museum of Natural History Passages with ReadWorks Curriculum',
	state: { s0: ['404', '405'], t: 0, cid: ['405'], pt: ['A'] }
});

vueComponentRoute('/rw/honoring-memorial-day', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Recognize Memorial Day',
	state: { q: ['memorial day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/celebrate-black-history-month-2016', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Celebrate Black History Month',
	state: { q: ['african american'], t: 0 }
});

vueComponentRoute('/rw/poems-national-poetry-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Poems & Questions for National Poetry Month',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/k-1st-grade-authentic-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 2nd Grade Passages & Question Sets',
	state: { g: ['16', '17'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/rising-3rd-4th-5th-graders-summer-reading', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'SummerReads for Rising 3rd, 4th, 5th Graders',
	state: { q: ['summerreads'], g: ['19', '18', '20', '21', '22'], t: 0 }
});

vueComponentRoute('/rw/new-paired-texts-and-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Paired Texts & Question Sets',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/life-science', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Articles for K-12',
	state: { s0: ['373', '356'], t: 0, s: ['356'] }
});

vueComponentRoute('/rw/poetry-month-part-2', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'More Poems for 6th - 12th Grade',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/science-3rd-5th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd- 5th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['19', '20', '21'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-literary-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages & Text-Dependent Questions',
	state: { s0: ['374'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/k-2nd-grade-social-studies-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['16', '17', '18'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/evidence-text-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Access denied',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/paired-texts-and-question-sets-test-prep', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Paired Texts & Question Sets',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/practice-inferencing', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles to Practice Inferring',
	state: { s0: ['1', '7'], t: 0, k: ['7'], pt: ['A'] }
});

vueComponentRoute('/rw/5th-grade-build-backround-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: '5th-6th Grade - Build Background Knowledge',
	state: { s0: ['0'], g: ['21'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/informational-articles-text-dependent-questions-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Articles & Text-Based Questions',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/authentic-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Passages & Question Sets',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts & Question Sets',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-2nd-grade-winter-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-8th Grade Winter Passages & Lessons',
	state: { q: ['winter'], g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/biographies', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Biographies and Profiles',
	state: { q: ['biography'], t: 0 }
});

vueComponentRoute('/rw/national-poetry-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Poems & Questions for National Poetry Month',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Science Articles with Text-Based Questions',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Paired Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/k-12-grade-passages-build-reading-stamina', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages to Build Reading Stamina',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/build-knowledge-informational-articles-k-12', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Build Knowledge with Informational Articles',
	state: { t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/3rd-12th-grade-informational-articles-build-knowledge', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Informational Articles to Build Knowledge',
	state: { g: ['21', '20', '19', '22', '323', '343', '347', '346'], t: 12, pt: ['A'] }
});

vueComponentRoute('/rw/articles-stem-topics-3rd-5th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd- 5th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['19', '20', '21'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-2nd-grade-social-studies-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 12th Grade Social Studies Articles',
	state: { s0: ['372'], g: ['16', '17', '18'], t: 0, s: ['372'], pt: ['A'] }
});

vueComponentRoute('/rw/presidents-day-2016', 'find-content', {
	site: 'teacher',
	public: true,
	title: "Presidents' Day 2017",
	state: { q: ['presidents day'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-3-5', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages for 3rd - 5th Grade',
	state: { s0: ['374'], g: ['19', '20', '21'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/k-12-literary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12th Grade Literary Passages & Questions',
	state: { s0: ['374'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/science-passages-paired-literary-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th STEM Articles & Literary Paired Texts',
	state: { s0: ['373'], t: 13, s: ['373'], pt: ['P'] }
});

vueComponentRoute('/rw/k-2-spring-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-2nd Grade Informational Articles for Spring',
	state: { q: ['spring'], g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/k-12-poems-and-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Poems with Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'], pt: ['A'] }
});

vueComponentRoute('/health-and-fitness', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Health and Fitness',
	state: { s0: ['0'], q: ['health and fitness'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-paired-texts', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Paired Texts with Question Sets',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['P'] }
});

vueComponentRoute('/rw/summer-reading-5th-12th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Summer Reading - Rising 6th-12th Graders',
	state: { q: ['summer'], g: ['21', '22', '323', '343', '347', '346'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-stem-topics-6th-8th-grade', 'find-content', {
	site: 'teacher',
	public: true,
	title: '6th - 12th Grade Articles on STEM Topics',
	state: { s0: ['373'], g: ['22', '323', '343'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/science-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Articles',
	state: { s0: ['373'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/k-12-literary-passages-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Passages & Text-Dependent Questions',
	state: { s0: ['374'], t: 0, s: ['374'] }
});

vueComponentRoute('/rw/thanksgiving-2015-reading-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Thanksgiving 2015',
	state: { q: ['thanksgiving'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/literary-paired-texts-quesion-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Literary Paired Texts with Question Sets',
	state: { s0: ['374'], t: 0, s: ['374'], pt: ['P'] }
});

vueComponentRoute('/rw/new-k-12-article-day-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New ReadWorks Article-A-Day Sets',
	state: { s0: ['0'], t: 0, pt: ['AAD'] }
});

vueComponentRoute('/rw/earth-space-science', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Science Articles & Question Sets',
	state: { s0: ['373', '361'], t: 0, s: ['361'] }
});

vueComponentRoute('/rw/paired-texts-1', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Paired Texts',
	state: { t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/celebrate-native-american-heritage-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Native American Heritage Month',
	state: { s0: ['0'], q: ['native american'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-native-american-heritage-month', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Native American Heritage Month',
	state: { s0: ['0'], q: ['native american'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/geography', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Geography Articles',
	state: { s0: ['372', '353'], t: 0, s: ['353'] }
});

vueComponentRoute('/rw/k-8th-grade-winter-passages-lessons-0', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd-5th Grade Winter Passages & Lessons',
	state: { q: ['winter'], g: ['16', '17', '18', '19', '20', '21', '22', '323', '343'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/american-museum-natural-history-reading-readworks-curriculum', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'American Museum of Natural History Passages with ReadWorks Curriculum',
	state: { s0: ['404', '405'], t: 0, cid: ['405'], pt: ['A'] }
});

vueComponentRoute('/rw/halloween', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles for Halloween',
	state: { q: ['halloween'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/poetry-and-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Poems and Question Sets',
	state: { s0: ['374', '29'], t: 0, s: ['29'] }
});

vueComponentRoute('/rw/k-2nd-grade-authentic-passages-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K - 2nd Grade Passages & Question Sets',
	state: { g: ['16', '17', '18'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/arts-everyone', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Arts Articles and Questions',
	state: { s0: ['372', '359'], t: 0, s: ['359'], pt: ['A'] }
});

vueComponentRoute('/rw/introducing-3-5-paired-text-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Paired Text Question Sets',
	state: { g: ['20', '21', '19'], t: 0, pt: ['P'] }
});

vueComponentRoute('/rw/new-1st-2nd-grade-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New 1st & 2nd Grade STEM Articles',
	state: { s0: ['373'], g: ['17', '18'], t: 0, s: ['373'], pt: ['A'] }
});

vueComponentRoute('/rw/new-k-2nd-grade-science-articles', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Brand New 1st & 2nd Grade STEM Articles',
	state: { s0: ['373'], g: ['17', '16', '18'], t: 0, s: ['373'] }
});

vueComponentRoute('/rw/articles-lesson-related-weather', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles & Lessons Related to Weather',
	state: { s0: ['0'], q: ['weather'], t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/articles-about-weather', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Articles & Lessons Related to Weather',
	state: { s0: ['0'], q: ['weather'], t: 0, pt: ['A'] }
});

vueComponentRoute('/new-passages-fall-2013', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New K-8 Reading Passages',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/passages-academic-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Passages with Academic Vocabulary',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/reading-comprehension-passages-and-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Reading Comprehension Passages and Question Sets',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/brand-new-reading-comprehension-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-8 Passages',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/3rd-5th-grade-vocabulary', 'find-content', {
	site: 'teacher',
	public: true,
	title: '3rd - 5th Grade Vocabulary',
	state: { g: ['19', '20', '21'], t: 0, pt: ['A'] }
});

vueComponentRoute('/new-reading-comprehension-passages', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'New Reading Comprehension Passages',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/arts-articles-and-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Arts Articles and Questions',
	state: { s0: ['372', '359'], t: 0, s: ['359'], pt: ['A'] }
});

vueComponentRoute('/rw/passages-building-reading-stamina', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Passages for Building Reading Stamina',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/passages-text-dependent-questions', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'Passages with Text-Dependent Questions',
	state: { t: 0, pt: ['A'] }
});

vueComponentRoute('/rw/passages-evidence-based-question-sets', 'find-content', {
	site: 'teacher',
	public: true,
	title: 'K-12 Passages & Evidence-Based Question Sets',
	state: { t: 0, pt: ['A'] }
});

page('/welcome-coteacher/:classCode/:token', ctx => {
	userContext.setToken(ctx.params.token);
	let classCode = ctx && ctx.params ? ctx.params.classCode : '';
	let classAdmin = 'roster';
	let welcomeCoteacher = classCode;
	let memoryState = { welcomeCoteacher };
	let hashState = { classAdmin, classCode };
	page('/class-admin');
	model.set(hashState);
	model.set(memoryState);
});

page('/logout', function () {
	pubsub.publish('logout');
});

// students often enter /student as plural and get a 404,
// so catch that and send them where they want to go
page('/students', function () {
	page.redirect('/student');
});

vueComponentRoute('*', '404', { public: true });

module.exports = vueApp;
